import { NgModule, InjectionToken } from '@angular/core';
import { WrappedSocket } from './socket-io.service';
/** Socket factory */
export function SocketFactory(config) {
    return new WrappedSocket(config);
}
export var SOCKET_CONFIG_TOKEN = new InjectionToken('__SOCKET_IO_CONFIG__');
var SocketIoModule = (function () {
    function SocketIoModule() {
    }
    SocketIoModule.forRoot = function (config) {
        return {
            ngModule: SocketIoModule,
            providers: [
                { provide: SOCKET_CONFIG_TOKEN, useValue: config },
                {
                    provide: WrappedSocket,
                    useFactory: SocketFactory,
                    deps: [SOCKET_CONFIG_TOKEN]
                }
            ]
        };
    };
    SocketIoModule.decorators = [
        { type: NgModule, args: [{},] },
    ];
    return SocketIoModule;
}());
export { SocketIoModule };
//# sourceMappingURL=socket-io.module.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ngx-socket-io/src/socket-io.module.js
// module id = 438
// module chunks = 13